export const app = {
  name: "Assesment Web",
  color: {
    primary: "color_1",
    secondary: "color_1",
  },
  icon: "logo.svg",
};
